import { gql, useLazyQuery } from '@apollo/client';
import { CountriesModel } from '@utmost.co/enterprise-models';
import { FETCH_POLICY } from '../../../components/common/apollo/FETCH_POLICY';

export const GET_ISO_COUNTRIES = gql`
  query GET_ISO_COUNTRIES {
    isoCountries {
      items {
        name
        code
      }
    }
  }
`;

export function useGetISOCountries() {
  const [getCountries, { data, loading, error }] = useLazyQuery<{ isoCountries: CountriesModel }>(GET_ISO_COUNTRIES, {
    fetchPolicy: FETCH_POLICY.CACHE_FIRST
  });

  return {
    getCountries,
    loading,
    error,
    isoCountries: data?.isoCountries?.items.slice() || []
  };
}
